import { useSelector } from 'react-redux';
import { Box, Button, CircularFrame, ContentFrame, Icon, LayoutContent, LayoutContentCenter, LayoutControls, ScreenContainer, } from '@pinwheel/origami';
import React from 'react';
import { useGetLocalizedString } from '../hooks/useGetLocalizedString';
import useLinkNavigate from '../hooks/useLinkNavigate';
import ModalHeader from '../components/ModalHeader';
import { selectEmployerFromContext, selectLoadedPlatform, } from '../state/slices/slice-link-api';
import { selectShouldShowDDFormsFallback } from '../state/slices/slice-dd-form';
import { useDDFormContext } from '../hooks/useDDFormContext';
import CircledBang from '../assets/CircledBang';
import CompanyIcon from '../components/CompanyIcon';
import { ImageTitleLayout } from '../components/ImageTitleLayout';
var ManualInstructionsFallback = function () {
    var getLocalizedString = useGetLocalizedString();
    var navigate = useLinkNavigate();
    var loadedPlatform = useSelector(selectLoadedPlatform);
    var shouldShowDDForms = useSelector(selectShouldShowDDFormsFallback);
    var setDDFormEntryPoint = useDDFormContext().setDDFormEntryPoint;
    var employer = useSelector(selectEmployerFromContext);
    return (React.createElement(ScreenContainer, null,
        React.createElement(ModalHeader, { hideBackButton: true }),
        React.createElement(ContentFrame, null,
            React.createElement(LayoutContent, null,
                React.createElement(LayoutContentCenter, { "data-testid": "ManualInstructionsFallback" },
                    React.createElement(ImageTitleLayout, { title: getLocalizedString('AUTOMATED_DDS_DISABLED'), subtitle: loadedPlatform
                            ? getLocalizedString('PLATFORM_HAS_TEMPORARILY_DISABLED', [
                                loadedPlatform === null || loadedPlatform === void 0 ? void 0 : loadedPlatform.name,
                            ])
                            : getLocalizedString('GENERIC_TEMPORARILY_DISABLED') },
                        React.createElement(Box, { sx: {
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                '& > *': {
                                    marginRight: '8px',
                                },
                                '& > *:last-child': {
                                    marginRight: '0',
                                },
                            } },
                            React.createElement(CircularFrame, null,
                                React.createElement(Icon, { icon: "pinwheelLogo", size: 25, color: {
                                        type: 'theme',
                                        colorLegacy: 'Primary/50',
                                        colorNext: 'brand/default',
                                    } })),
                            React.createElement(Icon, { icon: "connector", size: 25, color: {
                                    type: 'theme',
                                    colorLegacy: 'Neutral/70',
                                    colorNext: 'neutral/default',
                                } }),
                            React.createElement(CircledBang, { size: 80, color: "#1170FF", secondaryColor: "#CCE0FF" }),
                            React.createElement(Icon, { icon: "connector", size: 25, color: {
                                    type: 'theme',
                                    colorLegacy: 'Neutral/70',
                                    colorNext: 'neutral/default',
                                } }),
                            React.createElement(CompanyIcon, { result: {
                                    logoUrl: (employer === null || employer === void 0 ? void 0 : employer.logoUrl) || (loadedPlatform === null || loadedPlatform === void 0 ? void 0 : loadedPlatform.searchLogoUrl),
                                } }))))),
            React.createElement(LayoutControls, null,
                React.createElement(Button, { variant: shouldShowDDForms ? 'ghost' : 'solid', eventId: "button-continue", dataTestId: "button-continue", onClick: function () {
                        navigate('/link-api/manual-instructions-display');
                    } }, getLocalizedString('VIEW_MANUAL_INSTRUCTIONS')),
                shouldShowDDForms && (React.createElement(Button, { "data-testid": "manualInstructionsFallback-useDDForm", onClick: function () {
                        setDDFormEntryPoint('manual_instructions_fallback');
                        navigate('/dd-form/primer');
                    } }, getLocalizedString('USE_A_FORM_INSTEAD')))))));
};
export default ManualInstructionsFallback;
